import React from 'react';
import Sidebar from '../Layout/Sidebar';
import Header from '../Layout/Header';
import { Home } from './Home';
import { FooterMobile } from '../Layout/FooterMobile';

const MainPageLayout: React.FC = () => {
    return (
        <div className="home-layout">
            <div className="sidebar-wrapper">
            <Sidebar />
            </div>
            <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                <Header />
                <main id="main" role="main">
                    <Home />
                </main>
                </div>
            </div>

            </div>
            <FooterMobile />
        </div>  
    );
};
export default MainPageLayout;